/* eslint-disable */
import React, { useState } from "react";
import styles from "./PipelineCard.module.scss";
import { MdOutlineContentCopy } from "react-icons/md";
import {
  capitalizeWords,
  copyToClipboard,
  decryptedAdminID,
  dMMMYYYY_formate,
  getSubStageBadge,
  renderInterviewDate,
  textTruncate,
} from "../../utility";

import ActionMenu from "../Common/ActionMenu";
import { MyModal } from "../Common/Model/MyModal";
import ModalContainer from "../Common/Model/ModalContainer";

import { Autocomplete, TextField } from "@mui/material";
import {
  getReasons,
  updateCandidate,
  updateLeadStage,
} from "../../services/candidateServices";
import {
  GetCandidateQualifyDetials,
  PutCandidateType,
  checkMobileRegistration 
} from "../../apiServices";
import SuccessTick from "../success_tick";
import { AiOutlineClose } from "react-icons/ai";
import QualifyFresherform from "../../pages/Candidate/CandidateQualifyForm/FresherForm";
import ExperienceForm from "../../pages/Candidate/CandidateQualifyForm/ExperienceForm";
import { useSelector } from "react-redux";
import FormMainLayout from "../../pages/Candidate/NewCandidateForm/FormMainLayout";
const PipelineCard = ({
  data = {},
  activeTab = "leads",
  onSelectCandidate,
  onSelectLeadCandidate,
  onRefresh,
  onRegRefresh,
}) => {
  const isLead = activeTab === "leads";
  console.log(data,"mobileNumber")

  // ───────────────── STATE ─────────────────
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  const [leadQualifyFormOpen, setLeadQualifyFormOpen] = useState(false);
  const [selectedMobile, setSelectedMobile] = useState({
    mobileNumber: "",
    whatsappNumber: "",
  });
  const [showSuccessForm, setshowSuccessForm] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID === 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";
  const [oponRegisterForm, setOponRegisterForm] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [checkingRegistration, setCheckingRegistration] = useState(false);
const [showAlreadyModal, setShowAlreadyModal] = useState(false);
const [alreadyMobile, setAlreadyMobile] = useState("");

  const [status, setStatus] = useState({
    reasonId: null,
    notes: "",
  });

  const [errors, setErrors] = useState({
    reasonId: "",
  });

  const [optionList, setOptionList] = useState([]);
  const [loading, setLoading] = useState(false);

  // ───────────────── CLICK HANDLERS ─────────────────
  const handleClick = () => {
    if (typeof onSelectCandidate === "function") {
      onSelectCandidate(data);
    }
  };

  const handleLeadClick = () => {
    if (typeof onSelectLeadCandidate === "function") {
      onSelectLeadCandidate(data);
    }
  };

  // ───────────────── MENU ACTION ─────────────────
  const handleOpenModal = async ({
    label,
    stage_id,
    sub_stage_id,
    candidate,
  }) => {
    setModalType(label);
    setSelectedCandidate(candidate);
    setSelectedAction({ stage_id, sub_stage_id });

    setStatus({
      reasonId: null,
      notes: "",
    });

    setErrors({
      reasonId: "",
    });

    setOpenModal(true);

    // fetch reasons
    try {
      const res = await getReasons(label);
      setOptionList(res.data || res || []);
    } catch (err) {
      console.log(err);
    }
  };

  // ───────────────── MENU OPTIONS ─────────────────
  let menuOptions = [];

  if (isLead) {
  menuOptions = [
    // ...(data.is_registered == 1
    //   ? [
    //       {
    //         label: "Qualified",
    //         action: () =>
    //           handleOpenQualifyForm(
    //             data.mobile_number || data.phone,
    //             data.whatsapp_number || data.whatsapp
    //           ),
    //       },
    //     ]
    //   : []),

    ...(data.is_registered == 0
      ? [
          {
             label: checkingRegistration ? "Checking..." : "New Register",
        action: () => handleNewRegister(data.id, data.mobile_number),
          },
        ]
      : []),

    {
      label: "Call Not Attended",
      action: () =>
        handleOpenModal({
          label: "Call Not Attended",
          sub_stage_id: 2,
          candidate: data,
        }),
    },

    {
      label: "Awaiting Resume",
      action: () =>
        handleOpenModal({
          label: "Awaiting Resume",
          sub_stage_id: 3,
          candidate: data,
        }),
    },

    {
      label: "Not Qualified",
      action: () =>
        handleOpenModal({
          label: "Not Qualified",
          sub_stage_id: 5,
          candidate: data,
        }),
    },

    {
      label: "Not Interested",
      action: () =>
        handleOpenModal({
          label: "Not Interested",
          stage_id: 26,
          candidate: data,
        }),
    },

    ...(((data.is_registered == 1 &&
      data.registered_moved == 0 &&
      data.lead_deactive == 0) ||
      isSuperAdmin ||
      isTeamLeader)
      ? [
          {
            label: "Delete Lead",
            action: () =>
              handleOpenModal({
                label: "Delete Lead",
                stage_id: 31,
                candidate: data,
              }),
          },
        ]
      : []),
  ];
}

  // ───────────────── FORM HANDLERS ─────────────────
  const handleAutoChange = (event, value) => {
    setStatus((prev) => ({
      ...prev,
      reasonId: value?.id || null,
    }));

    setErrors((prev) => ({
      ...prev,
      reasonId: "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setStatus((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const toInt = (val) => (val ? Number(val) : null);
  // ───────────────── SUBMIT ─────────────────
  const handleSubmit = async () => {
    console.log(status);

    if (showReason && !status.reasonId) {
      setErrors({ reasonId: "Reason is required" });
      return;
    }
    const selectedReason = optionList.find(
      (item) => item.id === status.reasonId,
    );
    const payload = {
      lead_id: selectedCandidate?.id,
      from_stage_id: selectedCandidate?.current_stage_id,
      from_sub_stage_id: selectedCandidate?.current_sub_stage_id,
      to_stage_id: selectedAction?.stage_id || null,
      to_sub_stage_id: selectedAction?.sub_stage_id || null,
      reason_id: status.reasonId || null,
      custom_reason: selectedReason?.reason_name || null,
      notes: status.notes || null,
      admin_id: parseInt(decryptedAdminID()) || null,
    };

    // console.log("Payload 👉", payload);

    try {
      setLoading(true);
      await updateLeadStage(payload);

      setOpenModal(false);

      if (typeof onRefresh === "function") {
        onRefresh();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const showReason = [
    "Call Not Attended",
    "Not Qualified",
    "Not Interested",
  ].includes(modalType);

  // ───────────────── UI HELPERS ─────────────────
  const renderSkills = (skills) => {
    if (!skills) return null;

    const skillArray = skills.split(",").map((s) => s.trim());

    return skillArray.slice(0, 4).map((skill, index) => (
      <span key={index} className={styles.skillBadge}>
        {skill}
      </span>
    ));
  };
  const subStageLabel = data.current_sub_stage_name || "";

  const badge = getSubStageBadge(subStageLabel);
  // ───────────────── UI ─────────────────

  const handleOpenQualifyForm = (mobileNumber, whatsappNumber) => {
    setSelectedMobile({ mobileNumber, whatsappNumber }); // ✅ store it
    setLeadQualifyFormOpen(true);

    GetCandidateQualifyDetials(mobileNumber)
      .then((res) => {
        if (res && res.canLeadDetails) {
          setSelectedOption(
            res.canLeadDetails?.experienced ? "experience" : "fresher",
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching candidate details:", err);
      });
  };

 const handleNewRegister = async (leadId, mobileNumber) => {
  // console.log(leadId,"hhhhhh");
    setCheckingRegistration(true);

    try {
        const result = await checkMobileRegistration(mobileNumber);

        // If status is 400 - Already Registered
        if (result.status === 400) {
            setAlreadyMobile(mobileNumber);
            setShowAlreadyModal(true);
            return;
        }

        // If status is 200 - Available for registration
        if (result.status === 200) {
            setSelectedLeadId(leadId);
            setOponRegisterForm(true);
        }
    } catch (error) {
        console.error("Error checking mobile registration:", error);
    } finally {
        setCheckingRegistration(false);
    }
};
  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);

    let experiencedValue = false;
    if (selectedValue === "experience") {
      experiencedValue = true;
    }

    PutCandidateType(experiencedValue, selectedMobile.mobileNumber, "").then(
      (data) => {},
    );
  };
  function handleCloseQualifyForm() {
    setSelectedOption("");
    setLeadQualifyFormOpen(false);
    if (typeof onRefresh === "function") {
      onRefresh();
    }
  }
  function handleQualifyFormSubmit() {
    setshowSuccessForm(true);

    setTimeout(() => {
      setshowSuccessForm(false);
      setSelectedOption("");
      setLeadQualifyFormOpen(false);
    }, 1000);

    if (typeof onRefresh === "function") {
      onRefresh();
    }
    // setopenWhatsappTem(true);
    // HandleOpenCandidate();
    // candidateDetils();
    // getMetaLead();
  }
   function handleRegisteredFormSubmit() {
    // setshowSuccessForm(true);

    setTimeout(() => {
     setOponRegisterForm(false);
      setSelectedLeadId(null);
    }, 1000);

    if (typeof onRefresh === "function") {
      onRefresh();
    }
    if (typeof onRegRefresh === "function") {
      onRegRefresh();
    }
  }
  return (
    <>
      <div className={styles.card}>
        {/* Row 1 */}
        <div className={styles.row}>
          <span
            className={styles.name}
            onClick={isLead ? handleLeadClick : handleClick}
            title={isLead ? data.name : data.first_name + " " + data.last_name}
          >
            {textTruncate(
              isLead
                ? data?.name || "No Name"
                : data.first_name + " " + data.last_name,
              20,
            )}
          </span>

          <span className={styles.rowend}>
            {(data.source || data.from_source) && (
              <span className={styles.sourceBadge}>
                {data.source || data.from_source}
              </span>
            )}

            {isLead && (
              <span className={styles.date}>
                {renderInterviewDate(data.last_enquiry_at)}
              </span>
            )}
            {!isLead && (
              <span className={styles.date}>
                {dMMMYYYY_formate(data.created_time)}
              </span>
            )}

            {isLead && menuOptions.length > 0 && (
              <ActionMenu options={menuOptions} />
            )}
          </span>
        </div>

        {/* Role */}
        {(data.role || data.job_category) && (
          <div className={styles.role}>{data.role || data.job_category}</div>
        )}

        {/* Phone */}
        <div className={styles.row}>
          <span className={styles.phone}>
            {data.phone || data.mobile_number}
            <MdOutlineContentCopy
              className={styles.copyIcon}
              onClick={() => copyToClipboard(data.phone || data.mobile_number)}
            />
          </span>

          {isLead &&
            data.is_registered == 1 &&
            data.registered_moved == 0 &&
            data.lead_deactive == 0 && (
              <span className={styles.alreadyTag}>Already Registered</span>
            )}
          {isLead && data.is_registered == 1 && data.registered_moved == 1 && (
            <span className={styles.movedTag}>Registered Moved</span>
          )}

          {isLead && data.lead_deactive == 1 && (
            <span className={styles.alreadyTag}>Deactivate</span>
          )}

          {!isLead && data.deactivated == 1 && (
            <span className={styles.alreadyTag}>Deactivate</span>
          )}
        </div>

        {/* Location + Exp */}
        {/* {(data.pref_location || data.exp_in_years) && ( */}
        <div className={styles.row}>
          {data?.pref_location !== "" ? (
            <span className={styles.meta}>
              {capitalizeWords(data?.pref_location)}
            </span>
          ) : (
            <span className={styles.meta}>No Preferred Location</span>
          )}

          {(data.exp_in_years !== null || data.exp_in_years !== "") && (
            <span className={styles.meta}>{data.exp_in_years} yrs</span>
          )}
        </div>
        {/* )} */}

        {/* Footer */}
        <div className={styles.footer}>
          {!isLead && data.key_skill && (
            <div className={styles.skillWrapper}>
              {renderSkills(data.key_skill)}
            </div>
          )}
          {isLead && data.current_sub_stage_name != null && (
            <div>
              <span
                style={{
                  backgroundColor: badge.bg,
                  color: badge.color,
                  padding: "4px 8px",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "600",
                  display: "inline-block",
                  minWidth: "40px",
                  textAlign: "center",
                }}
                title={data.current_sub_stage_name}
              >
                {badge.label}
              </span>
            </div>
          )}
          {isLead && data.current_stage_name === "Not Interested" && (
            <>
              <span className={styles.NotInterested}>
                {data.current_stage_name}
              </span>
            </>
          )}

          <span className={styles.avatar} title={data.user_name}>
            {data?.user_name?.charAt(0)?.toUpperCase() || "?"}
          </span>
        </div>
      </div>

      {/* ───────────── MODAL ───────────── */}
      {openModal && (
        <MyModal>
          <ModalContainer onClose={() => setOpenModal(false)}>
            <div className="text-center">
              <b>{modalType}</b>
            </div>

            <p className="mt-2">
              Move candidate <b>{selectedCandidate?.name}</b> ?
            </p>

            {showReason && (
              <Autocomplete
                options={optionList}
                getOptionLabel={(o) => o.reason_name || ""}
                onChange={handleAutoChange}
                className="mt-3"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Reason"
                    error={!!errors.reasonId}
                    helperText={errors.reasonId}
                  />
                )}
              />
            )}

            <TextField
              fullWidth
              name="notes"
              label="Notes"
              className="mt-3"
              value={status.notes}
              onChange={handleChange}
            />

            <div className="d-flex justify-content-end gap-2 mt-3">
              <button
                onClick={() => setOpenModal(false)}
                className={styles.cancelButton}
              >
                No
              </button>

              <button
                onClick={handleSubmit}
                disabled={loading}
                className={styles.SubmitButton}
              >
                {loading ? "Saving..." : "Yes"}
              </button>
            </div>
          </ModalContainer>
        </MyModal>
      )}

      {leadQualifyFormOpen && (
        <MyModal>
          <ModalContainer>
            <>
              <div
                className={`container d-flex align-itmes-center justify-content-between`}
              >
                <div className="">
                  <p>
                    <b>Candidate lead qualify form</b>
                  </p>
                  <div className="d-flex">
                    {" "}
                    <div className={`me-2  ${styles.radioInput}`}>
                      {/* <label className="form-check-label me-3"> */}
                      <input
                        type="radio"
                        name="fresher"
                        id="fresherYes"
                        value="fresher"
                        className={`form-check-input `}
                        checked={selectedOption === "fresher"}
                        onChange={handleOptionChange}
                      />
                      <label for="fresherYes">Fresher</label>
                      {/* </label> */}
                    </div>
                    <div className={`me-2  ${styles.radioInput}`}>
                      <label className="form-check-label">
                        <input
                          type="radio"
                          name="experience"
                          id="experienceNo"
                          value="experience"
                          className={`form-check-input `}
                          checked={selectedOption === "experience"}
                          onChange={handleOptionChange}
                        />
                        <label for="experienceNo">Experience</label>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="ms-5">
                  <div
                    className="btn btn-outline-danger"
                    onClick={handleCloseQualifyForm}
                  >
                    <AiOutlineClose />{" "}
                  </div>
                </div>
              </div>

              <div>
                <div>
                  {selectedOption === "fresher" ? (
                    <>
                      {/* <div className={`${styles.Container}`}> */}{" "}
                      <QualifyFresherform
                        mobilenumber={selectedMobile.mobileNumber}
                        whatsappNumber={selectedMobile.whatsappNumber}
                        Reloadpage={handleQualifyFormSubmit}
                      />
                      {/* </div> */}
                    </>
                  ) : selectedOption === "experience" ? (
                    // <ExperinenceWorkingform
                    //   mobilenumber={selectedMobile}
                    // />
                    <ExperienceForm
                      mobileNumber={selectedMobile.mobileNumber}
                      whatsappNumber={selectedMobile.whatsappNumber}
                      Reloadpage={handleQualifyFormSubmit}
                    />
                  ) : null}
                </div>
              </div>
            </>
          </ModalContainer>
        </MyModal>
      )}
      {showSuccessForm && (
        <MyModal>
          <ModalContainer>
            <SuccessTick HeadText="Successfully" />
          </ModalContainer>
        </MyModal>
      )}
      {oponRegisterForm && (
        <MyModal>
          <ModalContainer>
            <>
              <div>
                <FormMainLayout
                  onClose={() => {
                    setOponRegisterForm(false);
                    setSelectedLeadId(null);
                    if (typeof onRefresh === "function") {
                      onRefresh();
                    }
                    if (typeof onRegRefresh === "function") {
                      onRegRefresh();
                    }
                  }}
                  leadId={selectedLeadId} // Make sure this prop name matches
                  dataType="can_lead" // Make sure this prop name matches
                  onSuccess={handleRegisteredFormSubmit}
                />
              </div>
            </>
          </ModalContainer>
        </MyModal>
      )}
            {/* ───────────── ALREADY REGISTERED POPUP MODAL ───────────── */}
      {showAlreadyModal && (
        <MyModal>
          <ModalContainer onClose={() => setShowAlreadyModal(false)}>
            <div className="text-end">
              <AiOutlineClose
                style={{ cursor: "pointer", fontSize: "20px" }}
                onClick={() => setShowAlreadyModal(false)}
              />
            </div>
            <div className="text-center p-3">
              <div
                style={{
                  fontSize: "50px",
                  marginBottom: "20px",
                }}
              >
                ⚠️
              </div>
              <h4 style={{ color: "#dc3545", marginBottom: "15px" }}>
                Already Registered!
              </h4>
              <p style={{ fontSize: "16px", marginBottom: "20px" }}>
                Mobile number <strong>{alreadyMobile}</strong> is already
                registered in the candidate table.
              </p>
              <button
                onClick={() => setShowAlreadyModal(false)}
                style={{
                  backgroundColor: "#dc3545",
                  color: "white",
                  border: "none",
                  padding: "8px 20px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Close
              </button>
            </div>
          </ModalContainer>
        </MyModal>
      )}
    </>
  );
};

export default PipelineCard;
